var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"height":"150","src":(_vm.api_url + "/" + (_vm.item.url))}})}
var staticRenderFns = []

export { render, staticRenderFns }